import axios from 'api';

// LiveKit and Storage credentials are now singleton resources per tenant (one row per tenant).
// There is no list endpoint and no DELETE — only GET and PUT/PATCH.

// Cross-tenant tenant list (kept for the credential-selector UI that needs a schema picker).
export const getAllCusotmers = () => {
  return axios.get(`/api/super/tenants/?page_size=1000`);
};

// LiveKit — /api/super/tenants/{schema}/livekit/

export const getLivekitData = (schema, signal) => {
  return axios.get(`/api/super/tenants/${schema}/livekit/`, { signal });
};

// PUT acts as create-or-update.
export const createLivekit = ({ schema, ...body }) => {
  return axios.put(`/api/super/tenants/${schema}/livekit/`, body);
};

export const updateLivekit = ({ schema, ...body }) => {
  return axios.patch(`/api/super/tenants/${schema}/livekit/`, body);
};

export const getSingleLiveKitData = (schema) => {
  return axios.get(`/api/super/tenants/${schema}/livekit/`);
};

// LiveKit SIP objects — live passthrough to the tenant's ATTACHED LiveKit
// server (nothing stored in our DB). Requires the LiveKit credentials above
// to be saved first.
//   trunks:  /api/super/tenants/{schema}/livekit/sip-trunks/[{trunkId}/]
//   rules:   /api/super/tenants/{schema}/livekit/dispatch-rules/[{ruleId}/]

export const getLivekitSipTrunks = (schema, signal) => {
  return axios.get(`/api/super/tenants/${schema}/livekit/sip-trunks/`, { signal });
};

// direction: 'inbound' | 'outbound'; trunk: LiveKit trunk payload.
export const createLivekitSipTrunk = ({ schema, direction, trunk }) => {
  return axios.post(`/api/super/tenants/${schema}/livekit/sip-trunks/`, { direction, trunk });
};

// Full replace of the trunk on LiveKit.
export const updateLivekitSipTrunk = ({ schema, trunkId, direction, trunk }) => {
  return axios.patch(`/api/super/tenants/${schema}/livekit/sip-trunks/${trunkId}/`, { direction, trunk });
};

export const deleteLivekitSipTrunk = ({ schema, trunkId }) => {
  return axios.delete(`/api/super/tenants/${schema}/livekit/sip-trunks/${trunkId}/`);
};

export const getLivekitDispatchRules = (schema, signal) => {
  return axios.get(`/api/super/tenants/${schema}/livekit/dispatch-rules/`, { signal });
};

export const createLivekitDispatchRule = ({ schema, rule }) => {
  return axios.post(`/api/super/tenants/${schema}/livekit/dispatch-rules/`, { rule });
};

export const updateLivekitDispatchRule = ({ schema, ruleId, rule }) => {
  return axios.patch(`/api/super/tenants/${schema}/livekit/dispatch-rules/${ruleId}/`, { rule });
};

export const deleteLivekitDispatchRule = ({ schema, ruleId }) => {
  return axios.delete(`/api/super/tenants/${schema}/livekit/dispatch-rules/${ruleId}/`);
};

// Storage — /api/super/tenants/{schema}/storage/

export const getStorageData = (schema, signal) => {
  return axios.get(`/api/super/tenants/${schema}/storage/`, { signal });
};

export const createStorage = ({ schema, ...body }) => {
  return axios.put(`/api/super/tenants/${schema}/storage/`, body);
};

export const updateStorage = ({ schema, ...body }) => {
  return axios.patch(`/api/super/tenants/${schema}/storage/`, body);
};

export const getSingleStorageData = (schema) => {
  return axios.get(`/api/super/tenants/${schema}/storage/`);
};

// ─── Legacy stubs ────────────────────────────────────────────────────────
import { removedStub } from 'api/_legacy';
// LiveKit / Storage are now singletons per tenant — there is no DELETE.
export const deleteLivekit = removedStub('deleteLivekit');
export const deleteStorage = removedStub('deleteStorage');
